// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { AdminBarComponent } from './admin-bar.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  declarations: [AdminBarComponent],
  exports: [AdminBarComponent],
  entryComponents: [AdminBarComponent]
})

export class AdminBarModule { }
